import apiClient from './apiClient';

const BASE = '/api/v1.0/subscription-plans';

/**
 * Subscription plans + tenant-plan assignment + ClickHouse admin wipes.
 *
 * Each method throws on non-2xx so callers can surface the real error.
 */
const plansApi = {
  list: async () => {
    const r = await apiClient.get(BASE);
    return r.data?.data || r.data;
  },
  create: async (plan) => {
    const r = await apiClient.post(BASE, plan);
    return r.data?.data || r.data;
  },
  update: async (id, plan) => {
    const r = await apiClient.put(`${BASE}/${id}`, plan);
    return r.data?.data || r.data;
  },
  setDefault: async (id) => {
    const r = await apiClient.post(`${BASE}/${id}/default`);
    return r.data?.data || r.data;
  },
  delete: async (id) => {
    await apiClient.delete(`${BASE}/${id}`);
    return true;
  },
  assignToOrg: async (planId, orgId) => {
    const r = await apiClient.post(`${BASE}/${planId}/assign/${orgId}`);
    return r.data?.data || r.data;
  },

  // ── Org listing helper — the operator (SUPER_ADMIN) org list used to
  // populate the "assign tenant to plan" dropdown. Endpoint:
  // GET /api/organizations (returns a plain array). Falls back to [] on error.
  listOrgs: async () => {
    try {
      const r = await apiClient.get('/api/organizations');
      return r.data?.data || r.data || [];
    } catch (_e) {
      return [];
    }
  },

  // ── ClickHouse admin: destructive per-org data wipes ─────────────────────
  wipeRumForOrg: async (orgId, orgSlug) => {
    const r = await apiClient.post(
      `/api/v1.0/admin/clickhouse/orgs/${orgId}/rum/wipe`,
      null,
      { params: { confirm: orgSlug } });
    return r.data;
  },
  wipeAllForOrg: async (orgId, orgSlug) => {
    const r = await apiClient.post(
      `/api/v1.0/admin/clickhouse/orgs/${orgId}/all/wipe`,
      null,
      { params: { confirm: orgSlug } });
    return r.data;
  },

  // ── Retention enforcement (per-tenant TTL via ALTER TABLE DELETE) ────────
  // Uses the existing settings.RetentionEnforcementService — daily 02:30 cron
  // plus this manual trigger. No status endpoint exists in the existing
  // service so the UI shows only the result of the most recent invocation.
  retentionStatus: async () => null,
  runRetention: async () => {
    const r = await apiClient.post('/api/v1.0/settings/retention/cleanup-all');
    // Existing controller wraps in ApiResponse: { success, message, data: {...} }
    const env = r?.data || {};
    return env.data || env;
  },
};

export default plansApi;
